import { FilterType } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { CompositeFilterDisplayMode } from './display-mode';
// Validators
const filterConfigValidator = Validator.object({
    enabled: Validator.boolean(),
    index: Validator.number(),
    isMultiselect: Validator.boolean()
});
const filmFiltersValidator = Validator.object({
    genre: filterConfigValidator,
    attribute: filterConfigValidator,
    category: filterConfigValidator,
    event: filterConfigValidator
});
const showtimeFiltersValidator = Validator.object({
    genre: filterConfigValidator,
    attribute: filterConfigValidator,
    event: filterConfigValidator
});
const subscriptionFiltersValidator = Validator.object({
    billingPeriod: filterConfigValidator,
    billingRecurrence: filterConfigValidator,
    subscription: filterConfigValidator
});
export const compositeFilterConfigValidator = Validator.any([
    Validator.object({
        filterType: Validator.isEqualTo(FilterType.Film),
        displayMode: Validator.oneOf(Object.values(CompositeFilterDisplayMode)),
        isFilterModalAnchoredToTop: Validator.optional(Validator.boolean()),
        filters: filmFiltersValidator
    }),
    Validator.object({
        filterType: Validator.isEqualTo(FilterType.Showtime),
        displayMode: Validator.oneOf(Object.values(CompositeFilterDisplayMode)),
        filters: showtimeFiltersValidator
    }),
    Validator.object({
        filterType: Validator.isEqualTo(FilterType.Subscription),
        displayMode: Validator.oneOf(Object.values(CompositeFilterDisplayMode)),
        filters: subscriptionFiltersValidator
    })
]);
const defaultCompositeFilterConfig = {
    filterType: FilterType.Film,
    displayMode: CompositeFilterDisplayMode.Auto,
    filters: {
        genre: {
            enabled: true,
            index: 0,
            isMultiselect: true
        },
        attribute: {
            enabled: true,
            index: 1,
            isMultiselect: true
        },
        category: {
            enabled: true,
            index: 2,
            isMultiselect: false
        },
        event: {
            enabled: true,
            index: 3,
            isMultiselect: true
        }
    }
};
export const defaultCompositeFilterConfigFilm = defaultCompositeFilterConfig;
export const defaultCompositeFilterConfigShowtime = {
    filterType: FilterType.Showtime,
    displayMode: defaultCompositeFilterConfig.displayMode,
    filters: {
        genre: defaultCompositeFilterConfig.filters.genre,
        attribute: defaultCompositeFilterConfig.filters.attribute,
        event: defaultCompositeFilterConfig.filters.event
    }
};
export const defaultCompositeFilterConfigSubscription = {
    filterType: FilterType.Subscription,
    displayMode: defaultCompositeFilterConfig.displayMode,
    filters: {
        billingPeriod: {
            index: 0,
            enabled: true,
            isMultiselect: false
        },
        billingRecurrence: {
            index: 1,
            enabled: true,
            isMultiselect: false
        },
        subscription: {
            index: 2,
            enabled: true,
            isMultiselect: true
        }
    }
};
